export const state = {
    keyword: '',
    previousRoute: () => {},
}

export const getters = {}

export const mutations = {
    UPDATE_KEYWORD(state, keyword) {
        // Normalize input - accept either format (spaces or underscores)
        state.keyword = (keyword || '').replace(/_/g, ' ').trim()
    },
    UPDATE_PREVIOUS_ROUTE(state, previousRoute) {
        state.previousRoute = previousRoute || {}
    },
}

export const actions = {}
